export const mergeUpdateObjectAtIndex = (array, newValue, index) =>
  updateObjectAtIndex(array, { ...array[index], ...newValue }, index)

export const updateObjectAtIndex = (array, newValue, index) => [
  ...array.slice(0, index),
  newValue,
  ...array.slice(index + 1),
]

export const removeItemFromArray = (array, item) =>
  removeItemAtIndex(array, array.indexOf(item))

export const removeItemAtIndex = (array, index) => [
  ...array.slice(0, index),
  ...array.slice(index + 1),
]

export const updateObjectWithMatchingId = (array, newValue, upsert) => {
  const match = array.find((el) => el.id === newValue.id)
  if (!match) {
    if (upsert) return [newValue, ...array]
    return array
  }
  const index = array.indexOf(match)
  return updateObjectAtIndex(array, newValue, index)
}

export const toggleArrayItem = (array, item) => {
  const index = array.indexOf(item)

  if (index > -1) return removeItemAtIndex(array, index)

  return array.concat([item])
}
